<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch201">
<p class="centerImage"><img alt="images" id="img14" src="images/img14.jpg"/></p>
<p class="caption">Lt. Gen. John C. Pemberton</p>
<p class="caption1"><em class="italic">National Archives</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_ch201.vue?00a7702b